
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		value: {
			type: String,
			required: true
		},
		hasError: Boolean,
		label: {
			type: [String, Object as ()=>TranslateResult]
		},
		fancy: Boolean,
		disabled: Boolean,
		autofocus: Boolean,
		placeholder: [String, Object as ()=>TranslateResult]
	},
	methods: {
		async onInput(input:string){
			let prevInput = this.value || "";
			this.$emit("input", input);
			await this.$nextTick();
			let regex = /^\d{0,8}$/;
			if (!regex.test(this.value)) {
				if (!regex.test(prevInput)){
					return;
				}
				await this.$nextTick();
				this.$emit("input", prevInput);
			}
		}

	}
});
